/** @file quadTarget: the part the quad handles and Ctrl+V act on (a drawable index of the drawn puppet). */
import type { ViewportCtx } from './viewportCtx';

/**
 * The selection's drawable when the drawn puppet has it, else the first drawable of the active selected node; -1
 * when neither names one (or nothing is drawn yet).
 */
export function quadTarget(ctx: ViewportCtx): number {
  const drawables = ctx.puppet()?.bundle.puppet.drawables;
  if (drawables === undefined) return -1;
  const { drawable, nodes } = ctx.store.getState().selection;
  const byId = drawable === null ? -1 : drawables.findIndex((d) => d.id === drawable);
  if (byId >= 0) return byId;
  const node = nodes.at(-1);
  return node === undefined ? -1 : drawables.findIndex((d) => d.node === node);
}
